import api from '../service'
import axios from 'axios'

let setUID = ({commit}, data) => {
    commit('UID', data)
}

let setUUID = ({commit}, data) => {
    commit('UUID', data)
}

let setUSERNAME = ({commit}, data) => {
    commit('USERNAME', data)
}

let setErrorState = ({commit}, data) => {
    commit('ERROR_STATE', data)
}

let setIsAuth = ({commit}, data) => {
    commit('IS_AUTH', data)
}

let setToken = ({commit}, data) => {
    commit('TOKEN', data)
}

let setNextRoute = ({commit}, data) => {
    commit('NEXT_ROUTE', data)
}

let setErrorCode = ({commit}, data) => {
    commit('ERROR_CODE', data)
}

let processResponse = (store, loginResponse) => {
	if (loginResponse && loginResponse.status == 200) {
        setUID(store, loginResponse.data.userId)
        setUUID(store, loginResponse.data.uuid)
        setUSERNAME(store, loginResponse.data.userName)
        setToken(store, loginResponse.data.jwt)
        setErrorState(store, '')
        setIsAuth(store, true)

        // 모든 HTTP 요청 헤더에 Authorization 을 추가한다.
        axios.defaults.headers.common['Jwt-Auth'] = loginResponse.data.jwt
        //redirect
        const vuex = JSON.parse(localStorage.getItem('vuex'))
        if(store.state.nextRoute){
            let nextRoute = store.state.nextRoute
            setNextRoute(store, '')
            document.location.href = nextRoute
        }else{
            document.location.href = '/'
        }

    } else {
		setErrorCode(store, loginResponse.data.errorCode)
		setErrorState(store, '아이디와 비밀번호를 확인해 주세요')
        axios.defaults.headers.common['Jwt-Auth'] = undefined
        setUID(store, '')
        setUUID(store, '')
        setToken(store, '')
        setIsAuth(store, false)
    }
}
export default {
    async login(store, {uid, password}) {
        let loginResponse = await api.login(uid, password)
        processResponse(store, loginResponse)
    },
    logout(store) {
        axios.defaults.headers.common['Jwt-Auth'] = undefined
        setUID(store, '')
        setUUID(store, '')
        setToken(store, '')
        setErrorState(store, '')
        setIsAuth(store, false)
        document.location.href = '/';
    },
    logoutToLogin(store) {
        //alert('로그인 세션이 만료되었습니다. 다시 로그인해 주세요')
        axios.defaults.headers.common['Jwt-Auth'] = undefined
        setUID(store, '')
        setUUID(store, '')
        setToken(store, '')
        setErrorState(store, '')
        setIsAuth(store, false)
        document.location.href = '/login';
    }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js